var map = {
	"./modules/global.js": "DZP5",
	"./modules/home.js": "Axeh",
	"./modules/login.js": "nxN4",
	"./modules/network.js": "19l/",
	"./modules/order.js": "nsMs",
	"./modules/role.js": "k2CX",
	"./modules/shop.js": "1pUN",
	"./modules/system.js": "vUVs",
	"./modules/user.js": "gAF4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1DKh";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/en-us ^\.\/modules\/([\s\S])+\.js$
// module id = 1DKh
// module chunks = 12